import React from "react";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./Home.css"; // your custom CSS
import { Responsive, WidthProvider } from "react-grid-layout";
import { useNavigate } from "react-router-dom";

// Import your logos
import adamsLogo from "../pictures/aLogo.png";
import berksLogo from "../pictures/berksC.png";
import cumberLogo from "../pictures/cumberCounty.png";
import dauphinLogo from "../pictures/dauphinCounty.png";
import juniataLogo from "../pictures/juniataCounty.png";
import LancasterLogo from "../pictures/lancasterCounty.png";
import lebanonLogo from "../pictures/lebanonCounty.png";
import mifflinLogo from "../pictures/mifflinCounty.png";
import northLogo from "../pictures/northCounty.png";
import perryLogo from "../pictures/perryCounty.png";
import schuylkillLogo from "../pictures/schCounty.png";
import yorkLogo from "../pictures/yorkCounty.png";
import snyderLogo from "../pictures/snyderCounty.png";

import comingSoon from "../pictures/comingSoon.png";

const ResponsiveGridLayout = WidthProvider(Responsive);

const widgets = [
  { key: "DauphinD", title: "Dauphin County Utility Info", url: "/municipality/Dauphin", icon: dauphinLogo},
  { key: "LebanonD", title: "Lebanon County Utility Info", url: "/utility", icon: comingSoon},
  { key: "LancasterD", title: "Lancaster County Utility Info", url: "/utility", icon: comingSoon},
  { key: "AdamsD", title: "Adams County Utility Info", url: "/municipality/Adams", icon: adamsLogo},
  { key: "CumberlandD", title: "Cumberland County Utility Info", url: "/municipality/Cumberland", icon: cumberLogo},
  { key: "YorkD", title: "York County Utility Info", url: "/utility", icon: comingSoon},
  { key: "PerryD", title: "Perry County Utility Info", url: "/municipality/Perry", icon: perryLogo},
  { key: "SnyderD", title: "Snyder County Utility Info", url: "/utility", icon: comingSoon},
  { key: "JuniataD", title: "Juniata County Utility Info", url: "/utility", icon: comingSoon},
  { key: "NorthumberlandD", title: "Northumberland County Utility Info", url: "/utility", icon: comingSoon},
  { key: "SchuylkillD", title: "Schuylkill County Utility Info", url: "/utility", icon: comingSoon},
  { key: "BerksD", title: "Berks County Utility Info", url: "/utility", icon: comingSoon},
  { key: "MifflinD", title: "Mifflin County Utility Info", url: "/utility", icon: comingSoon},

];

// Layout config: x, y = position; w = width; h = height
const layout = [
  { i: "AdamsD", x: 0, y: 0, w: 1, h: 2 },
  { i: "BerksD", x: 0, y: 3, w: 1, h: 2 },
  { i: "CumberlandD", x: 2, y: 0, w: 1, h: 2 },
  { i: "DauphinD", x: 1, y: 0, w: 1, h: 2 },
  { i: "JuniataD", x: 1, y: 1, w: 1, h: 2 },
  { i: "LancasterD", x: 2, y: 1, w: 1, h: 2 },
  { i: "LebanonD", x: 0, y: 2, w: 1, h: 2 },
  { i: "MifflinD", x: 1, y: 2, w: 1, h: 2 },
  { i: "NorthumberlandD", x: 2, y: 2, w: 1, h: 2 },
  { i: "PerryD", x: 0, y: 1, w: 1, h: 2 },
  { i: "SchuylkillD", x: 1, y: 3, w: 1, h: 2 },
  { i: "SnyderD", x: 2, y: 3, w: 1, h: 2 },
  { i: "YorkD", x: 0, y: 4, w: 3, h: 2 },
];

export default function Utility() {

 const navigate = useNavigate();

  // Define breakpoints and cols
  const breakpoints = { lg: 520, sm: 0 };
  const cols = { lg: 3, sm: 1 };

  // Layouts for each breakpoint
  const layouts = {
    lg: layout,
    sm: layout.map(item => ({ ...item, x: 0, w: 1 })), // stack vertically on small screens
  };

    const handleClick = (url) => {
    if (url.startsWith("http")) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      navigate(url);
    }
  };

  return (
    <div className="home-container-agent">
      <div className="grid-wrapper">
        <ResponsiveGridLayout
          className="layout"
          layouts={layouts}
          breakpoints={breakpoints}
          cols={cols}
          rowHeight={150}
          isResizable={false}
          isDraggable={false}
        >
          {widgets.map((widget) => (
            <div
              key={widget.key}
              className="widget-card"
              onClick={() => handleClick(widget.url)}
            >
              <img src={widget.icon} alt={widget.title} className="widget-icon" />
            </div>
          ))}
        </ResponsiveGridLayout>
      </div>
    </div>
  );
}